import { useLoaderStore } from '../store/localapi';

export async function fetchWithLoader(
    input: RequestInfo | URL,
    init?: RequestInit
): Promise<Response> {
    const baseurl = 'https://dramasstory.com/web/'
    const { showLoader, hideLoader } = useLoaderStore.getState();
    try {
        showLoader();
        const response = await fetch(baseurl+input, init);
        return response;
    } finally {
        hideLoader();
    }
}